import { usePublish } from "@/components/features/marketing/_shared/components/header/publish-button/hooks";

import { useMarketingCampaignFormModelContext } from "../../../../../_shared/context";
import { useMarketingExistingCampaignFormModelContext } from "../../../../context";

export const usePublishButton = () => {
	const { viewModel } = useMarketingCampaignFormModelContext();
	const { onPublish } = useMarketingExistingCampaignFormModelContext();

	return usePublish({
		inSale: viewModel.inSale.value,
		hasError: viewModel.hasError,
		isDirty: viewModel.isDirty,
		onPublish,
	});
};
